export default __webpack_public_path__ + "static/media/contributorSlide.8b3dadee.png";